import MarketoForm from "../../../../src/components/marketo-form";
import * as React from 'react';
export default {
  MarketoForm,
  React
};